import zipObject from 'lodash/zipObject';
import { getComputedColor } from '@/utils/color.js';
import { PendoColorNamesMap } from '@/constants/color-strings.js';

// COLORS
export const colorClasses = [
    '.groupColor01',
    '.groupColor02',
    '.groupColor03',
    '.groupColor04',
    '.groupColor05',
    '.groupColor06',
    '.groupColor07',
    '.groupColor08',
    '.groupColor09',
    '.groupColor10',
    '.groupColorUngrouped', // The "ungrouped" class must always be last
];

export const colors = [
    getComputedColor('var(--palette-pink-100)'),
    getComputedColor('var(--data-vis-magenta-vis-magenta-100)'),
    getComputedColor('var(--palette-orange-80)'),
    getComputedColor('var(--data-vis-orange-vis-orange-120)'),
    getComputedColor('var(--palette-teal-70)'),
    getComputedColor('var(--palette-green-90)'),
    getComputedColor('var(--data-vis-blue-vis-blue-130)'),
    getComputedColor('var(--data-vis-blue-vis-blue-100)'),
    getComputedColor('var(--data-vis-purple-vis-purple-120)'),
    getComputedColor('var(--data-vis-purple-vis-purple-100)'),
    getComputedColor('var(--palette-gray-70)'), // The "ungrouped" color must always be last
];

// Preset labels for color picker aria labels. Excludes ungrouped.
export const colorLabelsMap = {
    [colors[0]]: PendoColorNamesMap.regular.pink,
    [colors[1]]: PendoColorNamesMap.regular.magenta,
    [colors[2]]: PendoColorNamesMap.regular.orange,
    [colors[3]]: PendoColorNamesMap.light.orange,
    [colors[4]]: PendoColorNamesMap.regular.teal,
    [colors[5]]: PendoColorNamesMap.regular.green,
    [colors[6]]: PendoColorNamesMap.dark.blue,
    [colors[7]]: PendoColorNamesMap.regular.blue,
    [colors[8]]: PendoColorNamesMap.dark.purple,
    [colors[9]]: PendoColorNamesMap.regular.purple,
};

export const colorMap = zipObject(colorClasses, colors);

export const colorClassMap = zipObject(colors, colorClasses);

export const defaultColorClass = colorClasses[0];

export const defaultColor = colors[0];
